/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconWarning from 'DesignSystem/Svgs/TysiaIconWarning/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CheckInAction/AssignConnection/Content/Content/SkipConfirmation/Content",
  isSubmitting
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtTypographyFontsizeMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.mm'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let constantData = 'Automations for'
let checkInAppNameValueData = fromData.useDataValue({ viewPath,
context: 'check_in',
path: 'app_name',
})
let aggregateData = fromAggregate.join(constantData, checkInAppNameValueData)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let connectionsIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'connections',
})
let connectionsIsSubmittingData1 = fromData.useDataIsSubmitting({ viewPath,
context: 'connections',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 height="auto"
 width={400}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="Skip assigning connection"
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 justifyItems="center"
 style={{'--mb-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconWarning
  viewPath={`${viewPath}/TysiaIconWarning`}
 height={48}
 width={48}
 fill="#E9B949"
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size={dtTypographyFontsizeMm}
 marginBottom={dtSpaceXxs}
 textAlign="center"
 text="Are you sure you want to skip?"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 size={dtTypographyFontsizeM}
 textAlign="center"
 data="'Automations for'"
 data="check_in.app_name"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 textAlign="center"
 size={dtTypographyFontsizeM}
 text="won't run without a connection"
/>
</div>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<TysiaModalFooterAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="secondary"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../No'))}
 data="connections"
 disabled={connectionsIsSubmittingData}
 text="Cancel"
/>
<TysiaModalFooterAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="primary"
 onClick={onClick}
 data="connections"
 disabled={connectionsIsSubmittingData1}
 text="Skip"
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}